import React, { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { ClientLayout } from "../layouts";

const Home                  = lazy(() => import("../pages/web/Home/Home").then((m) => ({ default: m.Home })));
const GestionPages           = lazy(() => import("../pages/web/GestionHumana/GestionPages").then((m) => ({ default: m.GestionPages })));
const Formulario             = lazy(() => import("../pages/web/GestionHumana/Formulario").then((m) => ({ default: m.Formulario })));
const Contact                = lazy(() => import("../pages/web/Contact/Contact").then((m) => ({ default: m.Contact })));
const Nosotros               = lazy(() => import("../pages/web/SobreNosotros/SobreNosotros").then((m) => ({ default: m.Nosotros })));
const PagesSociosComerciales = lazy(() => import("../pages/web/SociosComerciales/PagesSociosComerciales").then((m) => ({ default: m.PagesSociosComerciales })));
const PagesProductos         = lazy(() => import("../pages/web/Productos/PagesProductos").then((m) => ({ default: m.PagesProductos })));
const NotFound               = lazy(() => import("../pages/web/NotFound/NotFound").then((m) => ({ default: m.NotFound })));

const wrap = (Page) => <ClientLayout><Page /></ClientLayout>;

export function WebRouter() {
  return (
    <Routes>
      <Route path="/"                      element={wrap(Home)} />
      <Route path="/recursohumano"         element={wrap(GestionPages)} />
      <Route path="/recursohumano/formulario" element={wrap(Formulario)} />
      <Route path="/contacto"              element={wrap(Contact)} />
      <Route path="/nosotros"              element={wrap(Nosotros)} />
      <Route path="/socios-comerciales"    element={wrap(PagesSociosComerciales)} />
      <Route path="/productos"             element={wrap(PagesProductos)} />
      <Route path="*"                      element={wrap(NotFound)} />
    </Routes>
  );
}
